import ContractIcon from '../../assets/svg/contract.svg';
import ContractIconSelected from '../../assets/svg/contract_selected.svg';
import DescriptionIcon from '../../assets/svg/description.svg';
import DescriptionIconSelected from '../../assets/svg/description_selected.svg';
import HomeIcon from '../../assets/svg/home.svg';
import HomeIconSelected from '../../assets/svg/home_selected.svg';
import DocumentDownload from '../../assets/svg/startIcon.svg';
import DocumentDownloadSelected from '../../assets/svg/startIconSelected.svg';
import TransactionIcon from '../../assets/svg/Transactions.svg';
import TransactionIconSelected from '../../assets/svg/Transactions_selected.svg';
import {useMenuVisibility} from '../../hooks/useMenuVisibility';
import {MENU_OPTIONS_UNLEASH_KEY} from '../../utils/constant';
import {Navigate} from '../../utils/util';

import {Box, Card, CardContent} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './Footer.css';
import {connect} from 'react-redux';

const Footer = ({
  selectedMenu,
  noScheduleData,
  contractCounts,
  pastContracts,
}) => {
  const {t} = useTranslation();
  const {flag: sidebarFlag, isItemVisible} = useMenuVisibility(
    MENU_OPTIONS_UNLEASH_KEY
  );

  return (
    <Box width={'100%'}>
      <Card square={true} raised={true}>
        <CardContent id="card-landing-footer">
          {noScheduleData || (sidebarFlag && !isItemVisible('home')) ? null : (
            <div
              className={`${selectedMenu === 'home' && 'selected-bg'}`}
              onClick={() => {
                Navigate('home');
              }}
            >
              {selectedMenu === 'home' ? (
                <img src={HomeIconSelected} alt="Home Selected" />
              ) : (
                <img src={HomeIcon} alt="Home" />
              )}
              <span
                className={`list-item ${selectedMenu === 'home' && 'selected'}`}
              >
                {t('HOME')}
              </span>
            </div>
          )}
          {!sidebarFlag || isItemVisible('paymentSchedule') ? (
            <div
              className={`${
                contractCounts <= 0
                  ? 'hide-menu'
                  : selectedMenu === 'paymentSchedule' && 'selected-bg'
              }`}
              onClick={() => Navigate('paymentSchedule')}
            >
              {selectedMenu === 'paymentSchedule' ? (
                <img src={TransactionIconSelected} alt="Payments Selected" />
              ) : (
                <img src={TransactionIcon} alt="Payments" />
              )}
              <span
                className={`list-item ${
                  selectedMenu === 'paymentSchedule' && 'selected'
                }`}
              >
                {t('PAYMENTS')}
              </span>
            </div>
          ) : null}
          {!sidebarFlag || isItemVisible('contractDetails') ? (
            <div
              className={`${
                contractCounts <= 0
                  ? 'hide-menu'
                  : selectedMenu === 'contractDetails' ||
                    selectedMenu === 'contractDetailsOverview'
                  ? 'selected-bg'
                  : ''
              }`}
              onClick={() =>
                Navigate(
                  contractCounts > 1
                    ? 'contractDetailsOverview'
                    : 'contractDetails'
                )
              }
            >
              {selectedMenu === 'contractDetails' ||
              selectedMenu === 'contractDetailsOverview' ? (
                <img src={DescriptionIconSelected} alt="Contracts Selected" />
              ) : (
                <img src={DescriptionIcon} alt="Contracts" />
              )}
              <span
                className={`list-item ${
                  selectedMenu === 'contractDetails' ||
                  selectedMenu === 'contractDetailsOverview'
                    ? 'selected'
                    : ''
                }`}
              >
                {t('CONTRACTS')}
              </span>
            </div>
          ) : null}
          {!sidebarFlag || isItemVisible('serviceRequest') ? (
            <div
              className={`${
                contractCounts <= 0
                  ? 'hide-menu'
                  : selectedMenu === 'serviceRequest' && 'selected-bg'
              }`}
              onClick={() => {
                Navigate('serviceRequest');
              }}
            >
              {selectedMenu === 'serviceRequest' ? (
                <img src={ContractIconSelected} alt="Request Selected" />
              ) : (
                <img src={ContractIcon} alt="Request" />
              )}
              <span
                className={`list-item ${
                  selectedMenu === 'serviceRequest' && 'selected'
                }`}
              >
                {t('REQUEST')}
              </span>
            </div>
          ) : null}

          {!sidebarFlag || isItemVisible('download') ? (
            <div
              className={`${
                contractCounts <= 0 &&
                (!pastContracts || pastContracts.length === 0)
                  ? 'hide-menu'
                  : selectedMenu === 'download' && 'selected-bg'
              }`}
              onClick={() => {
                Navigate('download');
              }}
              onKeyUp={() => {}}
            >
              {selectedMenu === 'download' ? (
                <img src={DocumentDownloadSelected} alt="download Selected" />
              ) : (
                <img src={DocumentDownload} alt="download" />
              )}
              <span
                className={`list-item ${
                  selectedMenu === 'download' && 'selected'
                }`}
              >
                {t('DOWNLOAD')}
              </span>
            </div>
          ) : null}
        </CardContent>
      </Card>
    </Box>
  );
};

export const mapStateToProps = (state) => {
  return {
    noScheduleData: state.appStates?.noScheduleData,
    contractCounts: state.appStates?.contractNumbers?.contractCounts,
    pastContracts: state.appStates?.contractNumbers?.pastContracts,
  };
};
export default connect(mapStateToProps)(Footer);
